// extracted by mini-css-extract-plugin
export default {"pageContents":"pageContents__78SPx"};